import { render, staticRenderFns } from "./IncomingOrders.vue?vue&type=template&id=1d66c1a3&scoped=true"
import script from "./IncomingOrders.vue?vue&type=script&lang=js"
export * from "./IncomingOrders.vue?vue&type=script&lang=js"
import style0 from "./IncomingOrders.vue?vue&type=style&index=0&id=1d66c1a3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d66c1a3",
  null
  
)

export default component.exports